module.exports = __webpack_public_path__ + "img/img_pop_bg_bonus.8c7f411a.png";